#import "../../../../core/select/fragments/activity-type-fragment.graphql"

mutation CreateActivityType($input: ActivityTypeCreateInput!) {
    activityTypeCreate(input: $input) {
        activityType {
            ...ActivityType
        }
    }
}
